module.exports.GLOBAL_API_DOMAIN = '/qrpos/';


// WEBPACK FOOTER //
// ./src/config/index.js